import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import DoneImg from '~/assets/images/done_v2.webp';
import DonePreviewImg from '~/assets/images/done_v2_preview.png';
import Button from '~/components/atoms/buttons/Button';
import Image from '~/components/atoms/Image';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

type Props = {
  onSubmit: () => void;
};

const DownsellSuccess: FC<Props> = ({ onSubmit }) => {
  const { t } = useTranslation('modal');

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <Image src={DoneImg} preview={DonePreviewImg} />
      </div>

      <Typography
        variant={Typographies.HEADLINE_MEDIUM}
        component="div"
        className={styles.title}
      >
        {t('downsell_v2.success_title', 'Discount Successfully Applied')}🎉
      </Typography>

      <Typography
        variant={Typographies.TITLE_MEDIUM}
        component="div"
        className={styles.text}
      >
        {t(
          'downsell_v2.success_text',
          'That means you’ll continue enjoying the benefits of Justdone, now at a better price',
        )}
      </Typography>

      <Button
        className={styles.button}
        variant="contained"
        color="primary"
        onClick={onSubmit}
      >
        {t('general:got_it', 'Got it')}
      </Button>
    </div>
  );
};

export default DownsellSuccess;
